import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';

import { NoDataToDisplayComponent } from '@connect-services/client/components/no-data-to-display/no-data-to-display.component';
import { ChartComponent } from '@connect-services/client/components/statistics/chart/chart.component';
import { SecurityService } from '@connect-services/client/services/security.service';
import { StatisticService } from '@connect-services/client/services/statistic.service';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ChartComponent, LoadingComponent, NoDataToDisplayComponent],
    selector: 'app-statistics-panel',
    templateUrl: './statistics-panel.component.html',
})
export class StatisticsPanelComponent {
    public readonly isPrintScreen = input<boolean>(false);
    public ready = output<boolean>();

    protected readonly securityService = inject(SecurityService);
    protected readonly statisticService = inject(StatisticService);

    public constructor() {
        effect(async () => {
            if (!this.statisticService.projectId() || !this.statisticService.standardId()) {
                return;
            }

            this.statisticService.wktStringMultipolygon();
            await this.statisticService.setStatistics(this.securityService.meSignal()!.id);
        });

        effect(() => {
            const pendingCount = this.statisticService.pendingCharts().length;

            if (!this.statisticService.isLoading() && !pendingCount) {
                this.ready.emit(true);
            }
        });
    }

    public updatePendingCharts(id: string): void {
        this.statisticService.pendingCharts.update((chartIds: string[]) => {
            return chartIds.filter((chartId: string) => chartId !== id);
        });
    }
}
